import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, inr, fmtDate } from "@/lib/api";
import { TableWrap, Empty, StatCard, th, td, tr } from "@/components/common";
import { nativeInput } from "@/components/market";
import { download } from "@/components/gst";

export function StaffLedgerTab({ staff }) {
  const [sid, setSid] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => { if (!sid && staff.length) { setSid(staff[0].id); } }, [staff, sid]);
  useEffect(() => {
    if (sid) { api.get(`/hr/ledger/${sid}`).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }
  }, [sid]);
  const bal = d?.balance || 0;
  return (
    <div data-testid="staff-ledger-tab">
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <select data-testid="staff-ledger-select" className={`${nativeInput} w-64`} value={sid} onChange={(e) => setSid(e.target.value)}>
          {staff.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        {d && <Button variant="outline" data-testid="staff-ledger-pdf" onClick={() => download(`/hr/ledger/${sid}/pdf`, {}, `Staff_Ledger_${d.staff.name}.pdf`)}><Download className="mr-1 h-4 w-4" />Download PDF</Button>}
      </div>
      {d && <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <StatCard testid="staff-ledger-earned" label="Total Salary (jama)" value={inr(d.earned, 2)} />
        <StatCard testid="staff-ledger-paid" label="Paid + Advance" value={inr(d.paid, 2)} />
        <StatCard testid="staff-ledger-balance" label={bal >= 0 ? "Staff ko dena baaki" : "Staff par advance baaki"} value={inr(Math.abs(bal), 2)} accent={bal > 0 ? "text-rose-600" : "text-emerald-600"} />
      </div>}
      <TableWrap>
        <thead><tr>{["Date", "Particulars", "Salary Earned", "Paid / Advance", "Balance"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
        <tbody>{(d?.rows || []).map((r, i) => (
          <tr key={i} className={tr} data-testid={`staff-ledger-row-${i}`}>
            <td className={td}>{fmtDate(r.date)}</td><td className={td}>{r.particulars}</td>
            <td className={`${td} amount`}>{r.earned ? inr(r.earned, 2) : ""}</td><td className={`${td} amount`}>{r.paid ? inr(r.paid, 2) : ""}</td>
            <td className={`${td} amount font-semibold`}>{inr(Math.abs(r.balance), 2)} {r.balance > 0 ? "Payable" : r.balance < 0 ? "Advance" : ""}</td>
          </tr>))}</tbody>
      </TableWrap>
      {d && !d.rows.length && <Empty testid="staff-ledger-empty" text="Is staff ki koi entry nahi" />}
      {!staff.length && <Empty testid="staff-ledger-nostaff" text="Pehle Staff Master me staff jodein" />}
    </div>
  );
}
